import React, { FC, memo } from 'react'
import { Link } from 'react-router-dom'
import CrossIcon from '../../icons/cross.svg'
import { LOCATION_TYPE_LABELS } from '../../types/location'

interface IProps {
  branchName?: string
  locationCode: string
  locationType?: string
  onClose: () => void
}

const LocationInventoryHeader: FC<IProps> = ({
  branchName,
  locationCode,
  locationType,
  onClose,
}) => {
  const typeLabel =
    (locationType && LOCATION_TYPE_LABELS[locationType]) || 'Location'

  return (
    <div className="order-modal_head">
      {branchName && (
        <div className="order-modal_head-number_branch form">{branchName}</div>
      )}
      <div className="order-modal_head-number form">
        <div className="order-modal_title">{typeLabel} -&nbsp;</div>
        <div className="order-modal_number -disabled">{locationCode}</div>
        <Link
          to="#"
          className="order-modal_back"
          onClick={(e) => {
            e.preventDefault()
            onClose()
          }}
        >
          <CrossIcon width={15} height={16} />
        </Link>
      </div>
    </div>
  )
}

export default memo(LocationInventoryHeader)
